// extracted by mini-css-extract-plugin
export default {"addStaffBtn":"staff_addStaffBtn__NqmO5","addStaffCont":"staff_addStaffCont__vPH74","exit":"staff_exit__Dv06F","checkaval":"staff_checkaval__8o5ny"};